<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :lg="6" style="margin-bottom: 15px;">
          <ele-pro-table
            ref="table"
            :datasource="url"
            :columns="columns"
            height="calc(100vh - 261px)"
            :need-page="false"
            :toolkit="[]"
            :current.sync="current"
            highlight-current-row
            class="type-table"
            tool-class="ele-toolbar-actions"
            @done="done">
            <template slot="toolbar">
              <span class="type-toolbar-title">类型分类</span>
            </template>
          </ele-pro-table>
        </el-col>
        <el-col :lg="18" style="margin-bottom: 15px;">
          <column-data
            v-if="current"
            ref="columnData"
            :channel-type-id="Number(current.id)"
            @types-changed="reloadTypes" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import ColumnData from './column-data';

export default {
  name: 'ChannelDscolumn',
  components: { ColumnData },
  data() {
    return {
      url: '/Channeltype/getchannelTypeList?sort_channel=in',
      columns: [
        { columnKey: 'index', type: 'index', label: '序号', width: 55, align: 'center' },
        { prop: 'channel_name', label: '类型名称', showOverflowTooltip: true, minWidth: 100 },
        { prop: 'channel_count', label: '通道数', width: 70, align: 'center' }
      ],
      current: null,
      keepTypeId: null
    };
  },
  activated() {
    this.reloadTypes();
  },
  methods: {
    reloadTypes() {
      this.keepTypeId = this.current ? Number(this.current.id) : null;
      if (this.$refs.table) {
        this.$refs.table.reload();
      }
    },
    refreshColumnData() {
      this.$nextTick(() => {
        if (this.$refs.columnData && typeof this.$refs.columnData.reload === 'function') {
          this.$refs.columnData.reload();
        }
      });
    },
    done(res) {
      const list = (res && res.data) || [];
      if (!list.length) {
        this.current = null;
        this.keepTypeId = null;
        return;
      }
      let row = list[0];
      if (this.keepTypeId != null) {
        const found = list.find((item) => Number(item.id) === Number(this.keepTypeId));
        if (found) row = found;
        this.keepTypeId = null;
      }
      this.$refs.table.setCurrentRow(row);
      this.refreshColumnData();
    }
  }
};
</script>

<style scoped>
.type-table ::v-deep .el-table__row {
  cursor: pointer;
}
.type-toolbar-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 32px;
  color: #303133;
}
</style>
